<template>
  <el-dialog title="合同附件" :visible.sync="DialogVisible" width="800px" :close-on-click-modal="false" :close-on-press-escape="false">
    <contract-file v-if="DialogVisible" :item-val="itemVal" :contract-num="contractNum" :contract-type="contactType" />
    <span slot="footer" class="dialog-footer">
      <el-button type="default" @click="DialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script type="es6">
import contractFile from '../../Chief/contract/common/contractFile';
export default {
  data () {
    return {
      DialogVisible: false,
      contractNum: '',
      itemVal: {},
      contactType: ''
    };
  },
  components: {
    contractFile
  },
  computed: {},
  methods: {
    showFile (code, val, contactType) {
      this.contractNum = code;
      this.itemVal = val;
      this.DialogVisible = true;
      this.contactType = contactType;
    }
  },
  mounted () {

  }
};
</script>
<style lang="less"></style>
